import { injectable } from '@theia/core/shared/inversify';
import { TerminalThemeService } from '@theia/terminal/lib/browser/terminal-theme-service';

/** Read an LVGL `*, *, *` RGB token from body and return `rgb(r, g, b)`. */
const lvglRgb = (variable: string): string | undefined => {
    const rgb: string = getComputedStyle(document.body).getPropertyValue(variable).trim();
    return rgb ? `rgb(${rgb})` : undefined;
};

/**
 * Bridges LVGL CSS tokens (tokens.css) to xterm's programmatic theme.
 * CSS/Theia ColorRegistry cannot paint the terminal canvas; this service reads
 * the same --lvgl-* variables used by themes.css and terminal.css.
 */
@injectable()
export class LvglTerminalThemeService extends TerminalThemeService {
    override get theme() {
        const background: string | undefined = lvglRgb('--lvgl-bg-primary-rgb');
        const foreground: string | undefined = lvglRgb('--lvgl-text-primary-rgb');

        return {
            ...super.theme,
            ...(background ? { background } : {}),
            ...(foreground ? { foreground, cursor: foreground } : {})
        };
    }
}
